export default "__VITE_ASSET__cZKethsw__"